import { Grid } from '@mui/material'
import { useContext } from 'react'
import type { LogoInfo } from '../interfaces/LogoIf'
import { LanguageContext } from '../util/LanguageContext'
import { CustomCard } from './CustomCard'

type LogoListProps = {
  items: LogoInfo[]
  onEditLogo: (id: string, newText: string, file?: File) => void
  onDeleteLogo: (id: string) => void
}
export const LogoList: React.FC<LogoListProps> = props => {
  // 文字列変換用
  const translation = useContext(LanguageContext)

  return (
    <>
      {props.items.map(logo => (
        <Grid item lg={6} xl={4}>
          <CustomCard
            title={translation['label_logo']}
            id={logo.logo_id}
            text={logo.text}
            file={logo.storage_path}
            onEdit={(id, newText, file) => props.onEditLogo(id, newText, file)}
            onDel={id => props.onDeleteLogo(id)}
          />
        </Grid>
      ))}
    </>
  )
}
